import { Component, ChangeDetectionStrategy } from '@angular/core';
import { BranchService } from '../../services/branch.service';
import { Branch } from '../../interfaces/branch.interface';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatDialogModule } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-branch-selection',
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatDialogModule
  ],
  templateUrl: './branch-selection.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './branch-selection.component.scss',
})
export class BranchSelectionComponent {

  branches: Branch[] = [];
  selectedBranchId: number | null = null;
  loading = false;

  constructor(
    public dialogRef: MatDialogRef<BranchSelectionComponent>,
    public snackBar: MatSnackBar,
    private branchService: BranchService
  ) {
  }

  ngOnInit(): void {
    this.loadBranches();
  }

  loadBranches(): void {
    this.loading = true;
    this.branchService.getBranches().subscribe({
      next: (branches) => {
        this.branches = branches;
        this.loading = false;
      },
      error: () => {
        this.snackBar.open('Nie można załadować oddziałów', 'Zamknij', { duration: 3000 });
        this.loading = false;
      }
    });
  }

  selectBranch(branchId: number): void {
    this.selectedBranchId = branchId;
  }

  confirm(): void {
    if (this.selectedBranchId) {
      this.dialogRef.close(this.selectedBranchId);
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }

  formatDescription(description?: string): string {
    if (!description) return '';
    return description.replace(/\n/g, '<br>');
  }
}
